import { createFileRoute } from '@tanstack/react-router';
import { COMMUNITY_TOPIC_KEYS, type CommunityTopicKey } from '@zoxo/shared';

import { PageContainer } from '../components/layout/page-container';
import { CommunityList } from '../features/community/community-list';
import { postsQuery } from '../features/community/use-posts';
import { awaitOnServer } from '../lib/await-on-server';
import { pageHead } from '../lib/seo';
import { canonical } from '../lib/site';

/** 커뮤니티 목록 (/posts?topic=). loader 가 서버에서 첫 페이지를 채운다. */
export const Route = createFileRoute('/posts/')({
  // 모르는 게시판은 undefined 로 **덮어쓴다** — 키를 빼면 라우터가 원래 값(?topic=free)을 남겨 API 가 422 를 준다.
  validateSearch: (search): { topic?: CommunityTopicKey } => {
    const t = search.topic;
    return { topic: typeof t === 'string' && (COMMUNITY_TOPIC_KEYS as readonly string[]).includes(t) ? (t as CommunityTopicKey) : undefined };
  },
  loaderDeps: ({ search: { topic } }) => ({ topic }),
  loader: ({ context: { queryClient }, deps: { topic } }) =>
    awaitOnServer(queryClient.ensureInfiniteQueryData(postsQuery(topic))),
  head: () => pageHead({ title: '커뮤니티', description: '좋소 과수원 커뮤니티', url: canonical('/posts'), type: 'website' }),
  component: CommunityPage,
});

function CommunityPage() {
  const { topic } = Route.useSearch();
  return (
    <PageContainer>
      <CommunityList topic={topic} />
    </PageContainer>
  );
}
